import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from 'primereact/button';
import React, { memo } from 'react';
import { translate } from 'i18n/jhipster-language';
export const CreateHeader = memo((props) => (_jsx("div", { className: `cms-dialog-header ${props.className ?? ''}`.trim(), children: props.headername })));
export const Footer = memo(props => (_jsxs("div", { className: `cms-mfe-dialog-footer ${props.className ?? ''}`.trim(), children: [_jsx(Button, { type: "button", label: translate('entity.action.close'), onClick: e => {
                e.preventDefault();
                props.closeDialog?.();
            }, className: "p-button-danger p-button-outlined" }), _jsx(Button, { disabled: !!props.updating, form: props.formId ?? undefined, label: props.footerLabel ?? translate('entity.action.save'), type: "submit" })] })));
